import { Link } from "react-router-dom";
import { Video } from "lucide-react";

import { DashboardTopbar } from "@/components/layout/DashboardTopbar";
import { DashboardSidebar } from "@/components/layout/DashboardSidebar";

export function MyPitchPage() {
  return (
    <div className="min-h-screen bg-[#F0F2F5]">
      <DashboardTopbar />

      <div className="md:grid md:min-h-[calc(100vh-64px)] md:grid-cols-[260px_1fr_300px]">
        <DashboardSidebar active="pitch" />

        <main className="min-w-0 px-5 py-8 pb-24 md:px-10 md:py-10 md:pb-10">
          <header className="mb-8">
            <h1 className="text-[24px] font-bold tracking-tight text-[#1a1a1a]">My pitch</h1>
            <p className="mt-1 text-[14px] text-[#6c757d]">
              Record one pitch — reuse it across every event
            </p>
          </header>

          <div className="rounded-[20px] border border-dashed border-[#e2e8f0] bg-white px-6 py-16 text-center">
            <Video className="mx-auto mb-3 h-10 w-10 text-[#cbd5e1]" />
            <p className="text-[15px] font-semibold text-[#475569]">Coming soon</p>
            <p className="mt-1 text-[13px] text-[#94a3b8]">
              For now, the pitch is recorded per event from the event page.<br className="hidden sm:inline" />
              Open one of your events to record or update your pitch there.
            </p>
            <Link
              to="/me/meetups"
              className="mt-5 inline-block rounded-[12px] bg-[#2563eb] px-5 py-2.5 text-[13px] font-semibold text-white hover:bg-[#1d4ed8]"
            >
              Go to my events
            </Link>
          </div>
        </main>

        <aside className="hidden border-l border-[#e2e8f0] bg-white px-6 py-8 md:block" />
      </div>
    </div>
  );
}
